import { SidebarSetup } from "./features/SidebarSetup/SidebarSetup";

import { Wrapper } from "./features/Wrapper/Wrapper";

import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ContentWrapper } from "./features/ContentWrapper/ContentWrapper";
import { NotFound } from "./pages/NotFound/NotFound";
import { useNavigationData } from "./navigation-data";
import { Main } from "./pages/Main/Main";
import { Article } from "./pages/Article/Article";
import { Zin } from "./pages/Zin/Zin";
import { EhoZin } from "./pages/Zin/EhoZin";
import { PlatformContext } from "./contexts/PlatformContext";
import {EhoAuthor} from "./pages/Zin/EhoAuthor";

const RenderRoute = (item) => {
  return <>
    <Route key={item.path.slice(1)} path={item.path} element={item.component} />
    {item?.subItems?.map(RenderRoute)}
  </>
}


const App = () => {
  const navigationData = useNavigationData()
  const [userPlatformType, setUserPlatformType] = useState(window.innerWidth <= 800 ? 'mobile' : 'web');

  useEffect(() => {
    const handleResize = (event) => {
      if (event.target.innerWidth <= 800){
        setUserPlatformType('mobile');
      } else {
        setUserPlatformType('web');
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])


  return (
    <PlatformContext.Provider
        value={{userPlatformType}}
      >
      <Wrapper>
        <Router>
          <SidebarSetup />

          <ContentWrapper>
            <Routes>
              {navigationData.map(RenderRoute)}

              <Route key="main" path="/" element={<Main />} />
              <Route key="article" path="/articles/:id" element={<Article />} />
              <Route key="zin" path="/zins/:id" element={<Zin />} />
              <Route key="eho" path="/zins/eho" element={<EhoZin />} />
              <Route key="eho_author" path="/zins/eho/authors/:id" element={<EhoAuthor />} />
              {/*<Route key="zin_article" path="/zins/article/:id" element={<ZinArticle />} />*/}
              <Route key="not_found" element={<NotFound />} />
            </Routes>
          </ContentWrapper>
        </Router>
      </Wrapper>
    </PlatformContext.Provider>
  );
}

export default App;
